import { useMutation, useQueryClient } from '@tanstack/react-query'
import { companyDetailKey } from './keys'
import { CompanyDetail } from 'api/company/companyDetail'
import { editMoney } from 'api/company/editMoney'

export const useEditCompanyMoneyMutation = (companyId: number) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (request: Omit<Parameters<typeof editMoney>[0], 'companyId'>) =>
      editMoney({
        ...request,
        companyId,
      }),
    onMutate: async (request) => {
      await queryClient.cancelQueries({ queryKey: companyDetailKey(companyId) })

      const previousCompanyDetail = queryClient.getQueryData(
        companyDetailKey(companyId)
      )

      queryClient.setQueryData<CompanyDetail>(
        companyDetailKey(companyId),
        (old) => {
          if (!old) return old

          return {
            ...old,
            invoiceDueDays: request.invoiceDueDays ?? old.invoiceDueDays,
            takeRate1099: request.takeRate ?? old.takeRate1099,
            bonusTakeRate: request.bonusTakeRate ?? old.bonusTakeRate,
            tipTakeRate: request.tipTakeRate ?? old.tipTakeRate,
            w2RegularTakeRate:
              request.w2RegularTakeRate ?? old.w2RegularTakeRate,
            w2DoubleTakeRate: request.w2DoubleTakeRate ?? old.w2DoubleTakeRate,
            w2OvertimeTakeRate:
              request.w2OvertimeTakeRate ?? old.w2OvertimeTakeRate,
            chargeCushionWorkers:
              request.chargeCushionWorkers ?? old.chargeCushionWorkers,
          }
        }
      )

      return { previousCompanyDetail }
    },
    onError: (_error, _, context) => {
      queryClient.setQueryData(
        companyDetailKey(companyId),
        context?.previousCompanyDetail
      )
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: companyDetailKey(companyId) })
    },
  })
}
